import { FiCreditCard } from "react-icons/fi";
import { useSelector } from "react-redux";
import { currencyPipe, datePipe } from "../../Utils/pipes";
import Logo2 from "../../Assets/img/Cardnet-Logo.png";
import { useState } from "react";
function CartGuest({ id, park, sendPayment }) {

  const [enable, setEnable] = useState(false);

  const checkHandler = () => {
    setEnable((e) => !e);
  };

  const sendPaymentHandler = () => {
    sendPayment();
  };

  return (
    <div className=" basis-auto tab-land:basis-5/12 small-desktop:basis-4/12">
      <div className="mx-12 mb-10 mt-10 phone:mb-30">
        <p className="text-4xl font-sans text-center tab-port:text-start">
          Factura
        </p>
        <div
          style={{
            paddingRight: "1rem",
            /*minHeight: "8rem",*/ maxHeight: "16rem",
          }}
          className=""
        >
          <div>
            <p className="mt-11 text-2xl">{datePipe(new Date())}</p>
            <div className="flex flex-row justify-between items-center gap-y-2 my-2">
              <p className="text-3xl">
                <span>${currencyPipe(park.tarifaParqueExt)} x 1 Ticket</span>
              </p>
              <p className="text-3xl">
                <span>${currencyPipe(park.tarifaParqueExt * 1)}</span>
              </p>
            </div>
          </div>
        </div>
        <div className="dividir-grey"></div>
        <div className="flex justify-between flex-col tab-port:flex-row">
          <p className="text-4xl mt-6">Paga con </p>
          <span className="w-[140px] pt-3">
            <img src={Logo2} alt="Logo cardnet" />
          </span>
        </div>
        <div className="mt-12 px-5 flex flex-row">
          <input
            onChange={checkHandler}
            type={"checkbox"}
            className="w-[15vw] h-[3vh] tab-port:w-[3vw] tab-port:h-[3vh] mt-[0.3em]"
          />
          <p className="text-xl px-6 text-justify">
            Acepto todos los&nbsp;
            <a
              href="/#/park/terminos"
              target="_blank"
              className="text-font-light link"
            >
              Términos y Condiciones
            </a>
            , así como también la
            <a
              href="/#/politicas"
              target="_blank"
              className="ml-3 text-font-light link"
            >
              Política de privacidad
            </a>
            &nbsp;del Ministerio de Medio Ambiente y Recursos Naturales.
          </p>
        </div>
        <div className="Contenedor-boton">
          <button
            disabled={!enable ? true : false}
            onClick={sendPaymentHandler}
            className={
              enable
                ? "cursor-pointer py-6 px-32 text-4xl bg-[#003670] text-white rounded-lg"
                : "py-6 px-32 text-4xl bg-[#6e8dae] text-white rounded-lg"
            }
          >
            Pagar ahora <FiCreditCard className="icono inline-block" />
          </button>
        </div>
      </div>
      <div className="dividir"></div>
      <div className="mx-12 mb-12">
        <div className="flex justify-between gap-y-6 flex-col phone:flex-row">
          <p className="text-3xl">{"Total (RD$)"}</p>
          <p className="text-3xl">
            <span>${currencyPipe(park.tarifaParqueExt)}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export { CartGuest };
